import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#activity_report",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Activity Report")
  ])
], -1)
const _hoisted_3 = {
  id: "activity_report",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Type", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Start Date")
], -1)
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "End Date")
], -1)
const _hoisted_20 = { class: "col-md-2 mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_22 = {
  key: 1,
  disabled: "",
  type: "button",
  class: "btn btn-success mt-6 p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = { class: "collapse show" }
const _hoisted_29 = { class: "card-body p-0 mt-5" }
const _hoisted_30 = { class: "row w-100 mb-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Course Activity Report")
], -1)
const _hoisted_32 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_40 = { style: {"border-left":"1.5px solid #23ce10"} }
const _hoisted_41 = {
  class: "fw-bolder bg-light text-black",
  style: {"border-bottom":"1px solid #23ce10"}
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Sl ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Association ", -1)
const _hoisted_44 = {
  key: 0,
  class: "align-middle border border-gray-400 sticky-header"
}
const _hoisted_45 = {
  key: 1,
  class: "align-middle border border-gray-400 sticky-header"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Total Enrollment ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Female Enrolled ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " % of Female ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Total Certified ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Female Certified ", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " % of Female ", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Total Employed ", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " Female Employed ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("th", { class: "align-middle border border-gray-400 sticky-header" }, " % of Female ", -1)
const _hoisted_55 = { style: {} }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { colspan: "9" }
const _hoisted_58 = {
  key: 1,
  class: "border border-gray-400 text-center"
}
const _hoisted_59 = { colspan: "2" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "border border-gray-400 text-center" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Total ")
], -1)
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.entity_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                  options: _ctx.optionsTPartner,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Training Partner",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Training Type",
                  modelValue: _ctx.course_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.course_type) = $event)),
                  style: {"width":"100%"},
                  onChange: _ctx.btnCheckStatus
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "upskill",
                      label: "Up Skill"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Up Skill")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "newentrant",
                      label: "New Entrant"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("New Entrant")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_el_form_item, {
                  prop: "date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.start_date,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.start_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      type: "date",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_el_form_item, {
                  prop: "date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.end_date,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.end_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      type: "date",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.btnCheck)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseActivityReport())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_21
                    ]))
                  : (_openBlock(), _createElementBlock("button", _hoisted_22, [
                      _createTextVNode(" Search "),
                      _hoisted_23
                    ]))
              ])
            ]),
            (_ctx.showActivityReport == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
              : _createCommentVNode("", true),
            (_ctx.showActivityReport == true)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                              title: "Download Xlse",
                              "data-v-54b12dc8": "",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportTrainee()))
                            }, _hoisted_34),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Download PDF",
                              "data-v-54b12dc8": "",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadPdf()))
                            }, _hoisted_36),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Print",
                              "data-v-54b12dc8": "",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPdf()))
                            }, _hoisted_38)
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_39, [
                          _createElementVNode("thead", _hoisted_40, [
                            _createElementVNode("tr", _hoisted_41, [
                              _hoisted_42,
                              _hoisted_43,
                              (_ctx.course_type == 'upskill')
                                ? (_openBlock(), _createElementBlock("th", _hoisted_44, " Target(Up Skill) "))
                                : _createCommentVNode("", true),
                              (_ctx.course_type == 'newentrant')
                                ? (_openBlock(), _createElementBlock("th", _hoisted_45, " Target(New Entrant) "))
                                : _createCommentVNode("", true),
                              _hoisted_46,
                              _hoisted_47,
                              _hoisted_48,
                              _hoisted_49,
                              _hoisted_50,
                              _hoisted_51,
                              _hoisted_52,
                              _hoisted_53,
                              _hoisted_54
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_55, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.activityReport, (info, key) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                (info?.trancheInfo?.entities != [])
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                                      _createElementVNode("td", _hoisted_57, [
                                        _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.entities, (data, inx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: inx,
                                    class: "border border-gray-400 text-center"
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.entity_short_name), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.targetTrainee)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.enrollment)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.female)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                    data?.female_enrollment_percentage
                                  )), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.certification)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.female_certification)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                    data?.certification_percentage?.toFixed(2)
                                  )), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.job_placement)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.female_job_placement)), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                    data?.job_placement_percentage?.toFixed(2)
                                  )), 1)
                                  ]))
                                }), 128)),
                                (info?.trancheInfo?.entities.length != [])
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [
                                      _createElementVNode("td", _hoisted_59, [
                                        _createElementVNode("b", null, " Subtotal(" + _toDisplayString(info?.trancheInfo?.label) + ")", 1)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalTrainee), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalenrollment), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalfemale), 1),
                                      _createElementVNode("td", null, [
                                        (info?.trancheInfo?.subTotalfemale != 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.numberWithCommas(
                                    (
                                      (info?.trancheInfo?.subTotalfemale /
                                        info?.trancheInfo?.subTotalenrollment) *
                                      100
                                    ).toFixed(2)
                                  )), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_61, "0.00"))
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalcertification), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalfemaleCertification), 1),
                                      _createElementVNode("td", null, [
                                        (
                                  info?.trancheInfo
                                    ?.subTotalfemaleCertification != 0
                                )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.numberWithCommas(
                                    (
                                      (info?.trancheInfo
                                        ?.subTotalfemaleCertification /
                                        info?.trancheInfo
                                          ?.subTotalcertification) *
                                      100
                                    ).toFixed(2)
                                  )), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_63, "0.00"))
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subtotal_job_placement), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subtotal_female_job_placement), 1),
                                      _createElementVNode("td", null, [
                                        (
                                  info?.trancheInfo
                                    ?.subtotal_female_job_placement != 0
                                )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.numberWithCommas(
                                    (
                                      (info?.trancheInfo
                                        ?.subtotal_female_job_placement /
                                        info?.trancheInfo
                                          ?.subtotal_job_placement) *
                                      100
                                    ).toFixed(2)
                                  )), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_65, "0.00"))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            _createElementVNode("tr", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.TotalTrainee)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.Totalenrollment)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.Totalfemale)), 1),
                              _createElementVNode("td", null, [
                                (this.Totalfemale != 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.numberWithCommas(
                                  (
                                    (this.Totalfemale / this?.Totalenrollment) *
                                    100
                                  ).toFixed(2)
                                )), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_69, "0.00"))
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.Totalcertification)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.TotalcertificationFemale)), 1),
                              _createElementVNode("td", null, [
                                (this.TotalcertificationFemale != 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.numberWithCommas(
                                  (
                                    (this.TotalcertificationFemale /
                                      this?.Totalcertification) *
                                    100
                                  ).toFixed(2)
                                )), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_71, "0.00"))
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.total_job_placement)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(this.total_female_job_placement)), 1),
                              _createElementVNode("td", null, [
                                (this.total_female_job_placement != 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(_ctx.numberWithCommas(
                                  (
                                    (this.total_female_job_placement /
                                      this?.total_job_placement) *
                                    100
                                  ).toFixed(2)
                                )), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_73, "0.00"))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}